import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
function auth() { const t = localStorage.getItem(ADMIN_TOKEN_KEY); return t ? { Authorization: `Bearer ${t}` } : {}; }

export const recapApi = {
  jobs: (event_id) => axios.get(`${API}/admin/recap/jobs`, { params: { event_id }, headers: auth() }).then((r) => r.data),
  generate: (body) => axios.post(`${API}/admin/recap/generate`, body, { headers: auth() }).then((r) => r.data),
  retryFailed: (event_id) => axios.post(`${API}/admin/recap/retry-failed`, {}, { params: { event_id }, headers: auth() }).then((r) => r.data),
  retryOne: (job_id) => axios.post(`${API}/admin/recap/jobs/${job_id}/retry`, {}, { headers: auth() }).then((r) => r.data),
  preview: (event_id, target_registration_id, kind = "member") =>
    axios.get(`${API}/admin/recap/preview`, { params: { event_id, kind, target_registration_id }, headers: auth() }).then((r) => r.data),
  eventRecap: (event_id) => axios.get(`${API}/admin/recap/event/${event_id}`, { headers: auth() }).then((r) => r.data),
  schedule: (body) => axios.post(`${API}/admin/recap/schedule`, body, { headers: auth() }).then((r) => r.data),
};
